import { MANIFEST_URL, R2_PUBLIC_BASE, WORKER_BASE } from "./config.js";

// ── Manifest ──────────────────────────────────────────────────
// manifest.json 結構（由 Worker 維護）：
// {
//   version: 1,
//   updatedAt: ISOString,
//   visits: {
//     "<visit_id>": {
//       photos: [{ id, exifDate, thumb, medium, original, uploader, uploadedAt, originalName, size }]
//     }
//   }
// }

export async function fetchManifest() {
  try {
    const res = await fetch(`${MANIFEST_URL}?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) {
      if (res.status === 404) return { version: 1, updatedAt: null, visits: {} };
      throw new Error(`Manifest HTTP ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    console.warn("fetchManifest failed:", err);
    return { version: 1, updatedAt: null, visits: {} };
  }
}

export function photoUrl(path) {
  return `${R2_PUBLIC_BASE}/${path}`;
}

// ── Covers（封面選擇）─────────────────────────────────────────
const COVERS_URL = `${R2_PUBLIC_BASE}/covers.json`;

export async function fetchCovers() {
  try {
    const res = await fetch(`${COVERS_URL}?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return {};
    return await res.json();
  } catch {
    return {};
  }
}

export async function setCover(visitId, photoId) {
  const res = await fetch(`${WORKER_BASE}/api/cover`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ visit_id: visitId, photo_id: photoId }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Cover HTTP ${res.status}`);
  return data;
}

// ── Session ticket（一次 Turnstile 換 10 分鐘 ticket，避開 single-use 限制）
export async function getSessionTicket(turnstileToken) {
  const res = await fetch(`${WORKER_BASE}/api/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ turnstile_token: turnstileToken }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const codes = Array.isArray(data.codes) ? ` [${data.codes.join(",")}]` : "";
    throw new Error(`${data.error || `Session HTTP ${res.status}`}${codes}`);
  }
  return { ticket: data.ticket, exp: data.exp };
}

// ── Upload ────────────────────────────────────────────────────
export async function uploadPhoto({ visitId, uploader, exifDate, thumb, medium, original, sessionTicket }) {
  const fd = new FormData();
  fd.append("visit_id", visitId);
  fd.append("uploader", uploader || "");
  fd.append("exif_date", exifDate ? new Date(exifDate).toISOString() : "");
  fd.append("session_ticket", sessionTicket);
  fd.append("thumb", thumb);
  fd.append("medium", medium);
  fd.append("original", original);

  const res = await fetch(`${WORKER_BASE}/api/upload`, {
    method: "POST",
    body: fd,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    console.warn("[upload-fail]", data);
    const reason = data.reason ? ` (${data.reason})` : "";
    throw new Error(`${data.error || `HTTP ${res.status}`}${reason}`);
  }
  return data;
}
